//Actions
import { ACTIVE_ADMIN, CLEAR_ADMIN } from '../actions/adminActions';

const initialState = {
  status: 'inactive'
};

export default function(state = initialState, action) {
  const { type } = action;
  
  switch (type) {
    case ACTIVE_ADMIN:
      return { status: 'active' }; 
    
    case CLEAR_ADMIN:
      return { status: 'inactive' };
  
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/adminReducer.js